import { createFileRoute } from "@tanstack/react-router";
import { VendorRegisterVenuePage } from "@/components/vendor/VendorRegisterVenuePage";

export const Route = createFileRoute("/vendor/register-venue")({
  head: () => ({
    meta: [
      { title: "Venue registrieren · Venue Portal" },
      { name: "description", content: "Registriere eine neue Venue für das Pulse Venue Portal." },
    ],
  }),
  component: VendorRegisterVenuePage,
});
